import type {
  BatchPreviewTransitionModelKey,
  BatchPreviewTransitionType,
} from "./batch-preview.type";

import { isValidId } from "@/utilities/id";

export const getBatchPreviewIds = (ids: string): number[] => {
  return ids
    .split(",")
    .map((id) => parseInt(id, 10))
    .filter(isValidId);
};

/**
 * Transition
 */

export const getBatchPreviewTransitionModelKey = (
  type: BatchPreviewTransitionType
): BatchPreviewTransitionModelKey => {
  return type === "transition-intervention" ? "intervention" : "observation";
};
